import n, { createRef as t, PureComponent as r } from "react";
import { BoldTool as e, ItalicTool as o, UnderlineTool as a, StrikeThroughTool as i, H1Tool as c, H2Tool as l, H3Tool as u, FontSizeDownTool as s, FontSizeUpTool as h, SubscriptTool as f, SuperscriptTool as p, LinkTool as y, ForeColorTool as d, BackColorTool as g, AlignLeftTool as v, AlignCenterTool as m, AlignRightTool as w, AlignFullTool as T, OrderedListTool as A, UnorderedListTool as b, HorizontalRuleTool as k, IFrameTool as E, ImageTool as x, AudioTool as L, VideoTool as C, UndoTool as N, RedoTool as S, ResetTool as F, ClearTool as H } from "edkit";

function I(t) {
  var r = this,
      e = this.icon,
      o = this.usable;
  return n.createElement("button", {
    key: e,
    type: "button",
    title: this.title,
    className: "btn btn-" + (this.active ? "" : "outline-") + "secondary mr-2 mb-2",
    style: {
      cursor: o ? "pointer" : "not-allowed"
    },
    disabled: !o,
    onClick: function onClick() {
      return t.current && r.execute(t.current);
    }
  }, n.createElement("i", {
    className: "bi-" + e
  }));
}

function _(n, t) {
  n.prototype = Object.create(t.prototype), n.prototype.constructor = n, U(n, t);
}

function U(n, t) {
  return (U = Object.setPrototypeOf || function (n, t) {
    return n.__proto__ = t, n;
  })(n, t);
}

var z = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "type-bold", t.render = I, t;
  }

  return _(t, n), t;
}(e),
    O = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "type-italic", t.render = I, t;
  }

  return _(t, n), t;
}(o),
    R = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "type-underline", t.render = I, t;
  }

  return _(t, n), t;
}(a),
    j = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "type-strikethrough", t.render = I, t;
  }

  return _(t, n), t;
}(i),
    D = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "type-h1", t.render = I, t;
  }

  return _(t, n), t;
}(c),
    M = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "type-h2", t.render = I, t;
  }

  return _(t, n), t;
}(l),
    B = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "type-h3", t.render = I, t;
  }

  return _(t, n), t;
}(u),
    P = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "sort-alpha-down", t.render = I, t;
  }

  return _(t, n), t;
}(s),
    V = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "sort-alpha-up", t.render = I, t;
  }

  return _(t, n), t;
}(h),
    W = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "box-arrow-down-right", t.render = I, t;
  }

  return _(t, n), t;
}(f),
    q = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "box-arrow-up-right", t.render = I, t;
  }

  return _(t, n), t;
}(p),
    G = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "link", t.render = I, t;
  }

  return _(t, n), t;
}(y);

function J(t) {
  var r = t.type,
      e = t.value,
      o = t.onChange,
      a = t.icon;
  return n.createElement("span", {
    className: "d-inline-block align-middle position-relative " + t.className,
    title: t.title
  }, n.createElement("input", {
    className: "position-absolute w-100 h-100 rounded-lg",
    style: {
      left: 0,
      top: 0,
      zIndex: -1
    },
    type: "color",
    value: e,
    onChange: function onChange(n) {
      return o && o(n.target.value);
    }
  }), n.createElement("button", {
    className: "btn",
    style: {
      color: "color" === r ? e : "lightgray",
      backgroundColor: "color" === r ? "white" : e,
      borderColor: e
    },
    onClick: function onClick(n) {
      return n.currentTarget.previousElementSibling.click();
    }
  }, n.createElement("i", {
    className: "bi-" + a
  })));
}

function K(t) {
  var r = this,
      e = this.icon;
  return n.createElement(J, {
    className: "mr-2 mb-2",
    key: e,
    title: this.name,
    icon: e,
    type: this.colorName,
    value: this.getColor(),
    onChange: function onChange(n) {
      return t.current && r.execute(t.current, n);
    }
  });
}

var Q = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "file-earmark-font", t.render = K, t;
  }

  return _(t, n), t;
}(d),
    X = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "file-earmark-font-fill", t.render = K, t;
  }

  return _(t, n), t;
}(g),
    Y = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "text-left", t.render = I, t;
  }

  return _(t, n), t;
}(v),
    Z = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "text-center", t.render = I, t;
  }

  return _(t, n), t;
}(m),
    $ = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "text-right", t.render = I, t;
  }

  return _(t, n), t;
}(w),
    nn = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "justify", t.render = I, t;
  }

  return _(t, n), t;
}(T),
    tn = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "list-ol", t.render = I, t;
  }

  return _(t, n), t;
}(A),
    rn = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "list-ul", t.render = I, t;
  }

  return _(t, n), t;
}(b),
    en = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "reception-0", t.render = I, t;
  }

  return _(t, n), t;
}(k),
    on = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "window", t.render = I, t;
  }

  return _(t, n), t;
}(E),
    an = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "image", t.render = I, t;
  }

  return _(t, n), t;
}(x),
    cn = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "voicemail", t.render = I, t;
  }

  return _(t, n), t;
}(L),
    ln = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "camera-video", t.render = I, t;
  }

  return _(t, n), t;
}(C),
    un = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "arrow-counterclockwise", t.render = I, t;
  }

  return _(t, n), t;
}(N),
    sn = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "arrow-clockwise", t.render = I, t;
  }

  return _(t, n), t;
}(S),
    hn = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "eraser", t.render = I, t;
  }

  return _(t, n), t;
}(F),
    fn = function (n) {
  function t() {
    for (var t, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (t = n.call.apply(n, [this].concat(e)) || this).icon = "file-earmark-x", t.render = I, t;
  }

  return _(t, n), t;
}(H),
    pn = [z, O, R, j, D, M, B, P, V, W, q, G],
    yn = [Q, X],
    dn = [Y, Z, $, nn, tn, rn, en],
    gn = [on, an, cn, ln],
    vn = [un, sn, hn, fn],
    mn = [].concat(pn, yn, dn, gn, vn),
    wn = function (r) {
  function e() {
    for (var n, e = arguments.length, o = new Array(e), a = 0; a < e; a++) {
      o[a] = arguments[a];
    }

    return (n = r.call.apply(r, [this].concat(o)) || this).box = t(), n.state = {
      toolList: [],
      data: ""
    }, n.updateTools = function () {
      n.box.current === document.activeElement && n.setState({
        toolList: [].concat(n.state.toolList)
      });
    }, n;
  }

  _(e, r), e.getDerivedStateFromProps = function (n, t) {
    var r = n.value,
        e = t.toolList,
        o = t.data;
    return {
      toolList: e[0] ? e : n.tools.map(function (n) {
        return new n();
      }),
      data: o || r
    };
  };
  var o = e.prototype;
  return o.componentDidMount = function () {
    document.addEventListener("selectionchange", this.updateTools);
  }, o.componentWillUnmount = function () {
    document.removeEventListener("selectionchange", this.updateTools);
  }, o.render = function () {
    var t = this,
        r = this.state,
        e = r.data,
        o = this.props.onChange;
    return n.createElement(n.Fragment, null, n.createElement("header", null, r.toolList.map(function (n) {
      return n.render(t.box);
    })), n.createElement("div", {
      ref: this.box,
      className: "form-control h-auto",
      contentEditable: !0,
      dangerouslySetInnerHTML: {
        __html: e
      },
      onInput: function onInput(n) {
        return o && o(n.target.innerHTML);
      }
    }));
  }, e;
}(r);

export { Z as AlignCenterTool, nn as AlignFullTool, Y as AlignLeftTool, $ as AlignRightTool, cn as AudioTool, X as BackColorTool, z as BoldTool, fn as ClearTool, J as ColorSelector, yn as ColorTools, vn as ControlTools, wn as Editor, P as FontSizeDownTool, V as FontSizeUpTool, Q as ForeColorTool, D as H1Tool, M as H2Tool, B as H3Tool, en as HorizontalRuleTool, on as IFrameTool, an as ImageTool, O as ItalicTool, dn as LayoutTools, G as LinkTool, gn as MediaTools, tn as OrderedListTool, mn as OriginalTools, sn as RedoTool, hn as ResetTool, j as StrikeThroughTool, W as SubscriptTool, q as SuperscriptTool, pn as TextTools, R as UnderlineTool, un as UndoTool, rn as UnorderedListTool, ln as VideoTool, K as renderColorTool, I as renderTool };